const CompanyPendingActionTypeEnum = {
  CREDIT_REQUEST: "CREDIT_REQUEST",
  COMPANY_INVITED: "COMPANY_INVITED",
} as const;

export default CompanyPendingActionTypeEnum;
